import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';


import { TeemappTableComponent } from '@teem/shared-component/teemapp-table/teemapp-table.component';
import { ACTIONS as PROPOSAL_ACTIONS } from '@teem/constants/proposal';
import { ProposalService } from '@teem/services/proposal.service';
import { LoaderService } from '@teem/services/loader.service';
import { environment } from '@teem/environments/environment';
import { messages as i18n } from '@teem/constants/messages';

import ProposalsTableSchema from '@teem/proposals-module/classes/proposals-table-schema';
import DraftsTableSchema from '@teem/proposals-module/classes/drafts-table-schema';


declare var $;

@Component({
  selector: 'app-proposals',
  templateUrl: './proposals.component.html',
  styles: []
})
export class ProposalsComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @ViewChild('proposalsTableRef') proposalsTableRef: TeemappTableComponent;
  @ViewChild('draftsTableRef') draftsTableRef: TeemappTableComponent;

  totalProposals: number = 0;
  totalDrafts: number = 0;
  activeTab: string = 'all-proposals';
  previousTab: string;
  isSearch: boolean = false;
  activeProposal: any;
  routeSubscriber: any;

  proposalsTable: ProposalsTableSchema = new ProposalsTableSchema(this);
  proposalsMenuItems: Array<any> = [
    { key: "mark_as_sent", label: $localize`:@@ts.mark_as_sent:Mark as Sent`, onClick: this.markAsSent.bind(this) },
    { key: "mark_as_approved", label: $localize`:@@ts.mark_as_approved:Mark as Approved`, onClick: this.markAsApproved.bind(this) },
    { key: "mark_as_rejected", label: $localize`:@@ts.mark_as_rejected:Mark as Rejected`, onClick: this.markAsRejected.bind(this) },
    { key: "download_pdf", label: $localize`:@@ts.download_pdf:Download PDF`, onClick: this.downloadPDF.bind(this), singleOnly: true },
    { key: "email_proposals", label: $localize`:@@ts.email_proposals:Email Proposal`, onClick: this.emailProposals.bind(this) },
    { key: "delete_proposals", label: $localize`:@@ts.delete_proposals:Delete Proposals`, onClick: this.deleteProposals.bind(this) },
    { key: "convert_to_invoice", label: $localize`:@@ts.convert_to_invoice:Convert to Invoice`, onClick: this.convertToInvoice.bind(this) }
  ];

  draftsTable: ProposalsTableSchema = new DraftsTableSchema(this);
  draftsMenuItems: Array<any> = [
    { key: "view_draft", label: $localize`:@@ts.view:View`, onClick: this.viewDraft.bind(this), singleOnly: true },
    { key: "save_draft", label: $localize`:@@ts.save:Save`, onClick: this.convertToProposal.bind(this), singleOnly: true }
  ];
  isProposalSelected: boolean = false;
  isDraftSelected: boolean = false;
  fromDate: any;
  toDate: any;

  constructor(
    private loaderService: LoaderService,
    private proposalService: ProposalService,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
    this.routeSubscriber = this.route
      .queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        if (params && params['create-proposal']) {
          this.activeTab = "create-proposal";
        }
      });
  }

  onSelectDrafts(selected: Array<any>) {
    this.isDraftSelected = selected && selected.length > 0;
  }

  filterByDate() {
    let params: any = {};

    if (this.fromDate) {
      params.from_date = this.fromDate;
    }
    if (this.toDate) {
      params.to_date = this.toDate;
    }

    if (!(params.from_date || params.to_date)) {
      // On clear button click - Because we can't reset date filter individually for each table so here reload all tables when clear btn clicked. 
      this.proposalsTableRef.resetDateFilters();
      this.draftsTableRef.resetDateFilters();

      this.proposalsTableRef.getPage(1);
      this.draftsTableRef.getPage(1);
    } else if (params.from_date && params.to_date) {
      if (this.activeTab == 'all-proposals') {
        this.proposalsTableRef.getPage(1, false, params);
      } else if (this.activeTab == 'drafts') {
        this.draftsTableRef.getPage(1, false, params);
      }
    }
  }

  resetDateFilters() {
    if (this.fromDate || this.toDate) {
      this.fromDate = "";
      this.toDate = "";
      this.filterByDate();
    }
  }

  onSelectProposals(selected: Array<any>) {

    if (selected && selected.length) {
      let showMarkAsSent = false;
      let showMarkAsApproved = false;
      let showMarkAsRejected = false;
      let showConvertToInvoice = false;
      let showEmailProposal = false;

      selected.forEach((item) => {
        if (!item.sent_at)
          showMarkAsSent = true;

        if (!(item.status === "approved"))
          showMarkAsApproved = true;

        if (!(item.status === "rejected"))
          showMarkAsRejected = true;

        if (!item.invoice_id && item.status !== "rejected")
          showConvertToInvoice = true;

        if (item.client_has_email)
          showEmailProposal = true;
      })

      let markAsSentMenu: any = this.proposalsMenuItems.find(menu => menu.key == "mark_as_sent");
      let markAsApprovedMenu: any = this.proposalsMenuItems.find(menu => menu.key == "mark_as_approved");
      let markAsRejectedMenu: any = this.proposalsMenuItems.find(menu => menu.key == "mark_as_rejected");
      let convertToInvoiceMenu: any = this.proposalsMenuItems.find(menu => menu.key == "convert_to_invoice");
      let emailProposalMenu: any = this.proposalsMenuItems.find(menu => menu.key == "email_proposals");

      markAsSentMenu.visible = showMarkAsSent;
      markAsApprovedMenu.visible = showMarkAsApproved;
      markAsRejectedMenu.visible = showMarkAsRejected;
      convertToInvoiceMenu.visible = showConvertToInvoice;
      emailProposalMenu.visible = showEmailProposal;
    }

    this.isProposalSelected = selected && selected.length > 0;
  }

  toggleTableMenu() {
    if (this.activeTab == 'all-proposals') {

      if (this.isProposalSelected) {
        this.proposalsTableRef.toggleMenu();
      } else {
        Swal.fire(i18n.proposal.please_select_proposal);
      }
    } else if (this.activeTab == 'drafts') {

      if (this.isDraftSelected) {
        this.draftsTableRef.toggleMenu();
      } else {
        Swal.fire(i18n.proposal.please_select_draft);
      }
    }
  }

  switchTab(tab: string) {
    this.previousTab = this.activeTab;
    this.activeTab = tab;

    this.proposalsTableRef.reset();
    this.draftsTableRef.reset();

    if (this.route.snapshot.queryParams['create-proposal']) {
      this.router.navigateByUrl('proposals');
    }
  }

  goToPreviousTab() {
    if (this.previousTab) {
      this.activeTab = this.previousTab;
    } else {
      this.activeTab = "all-proposals";
    }

    if (this.route.snapshot.queryParams['create-proposal']) {
      this.router.navigateByUrl('proposals');
    }
  }

  searchProposals(term: string) {
    if (this.activeTab == 'all-proposals') {
      this.proposalsTableRef.search.next(term);
    } else if (this.activeTab == 'drafts') {
      this.draftsTableRef.search.next(term);
    }
  }

  toggleSearch() {
    this.isSearch = !this.isSearch;

    if (this.isSearch) {
      this.searchInput.nativeElement.focus();
    } else {
      this.searchInput.nativeElement.value = "";
      this.searchProposals("");
    }
  }

  onCreateProposal(data?: any) {
    this.previousTab = this.activeTab = data.action == 'draft' ? 'drafts' : 'all-proposals';

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }

  onEditProposal(data?: any) {
    this.previousTab = this.activeTab = data.action == 'draft' ? 'drafts' : 'all-proposals';

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }

  onLoadProposals(data: any) {
    this.totalProposals = data.totalItems ? data.totalItems : 0;

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }

  onLoadDrafts(data: any) {
    this.totalDrafts = data.totalItems ? data.totalItems : 0;

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }

  viewDraft(selected: Array<string>) {
    this.viewProposal({ uuid: selected[0] });
  }

  viewProposal(proposal: any) {
    this.loaderService.startLoading();

    this.proposalService.get(proposal.uuid).subscribe(data => {

      try {
        this.loaderService.stopLoading();
        this.activeProposal = data;
        this.switchTab('view-proposal');
      } catch (err) {
        // console.error(err);
      }
    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    })
  }

  editProposal(proposal?: any) {
    this.activeTab = 'edit-proposal';
  }

  convertToProposal(selected: Array<string>) {
    this.loaderService.startLoading();

    this.proposalService.action({ 'do': PROPOSAL_ACTIONS.CONVERT_TO_PROPOSAL, 'ids': selected }).subscribe(data => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.done, i18n.proposal.proposal_saved, 'success');

      this.proposalsTableRef.getPage(1);
      this.draftsTableRef.getPage(1);

    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    });
  }

  downloadPDF(selected: Array<string>) {
    (window as any).open(`${environment.baseUrl}/download-proposal/${selected[0]}/pdf?lang=${(window as any).LOCALE}`, '_blank');
  }

  emailProposals(selected: Array<string>) {
    if (selected.length) {
      this.loaderService.startLoading();

      this.proposalService.action({ 'do': PROPOSAL_ACTIONS.EMAIL, 'ids': selected }).subscribe(data => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.done, i18n.email_sent, 'success');

      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  deleteProposals(selected: Array<string>) {
    if (selected.length) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.proposal.you_want_to_delete_proposal,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
          i18n.yes,
        cancelButtonText:
          i18n.no_cancel_it
      }).then(result => {
        if (result.value) {
          this.loaderService.startLoading();

          this.proposalService.action({ 'do': PROPOSAL_ACTIONS.DELETE, 'ids': selected }).subscribe(data => {
            this.loaderService.stopLoading();

            if (this.activeTab == 'all-proposals') {
              this.proposalsTableRef.getPage(1);
            } else if (this.activeTab == 'drafts') {
              this.draftsTableRef.getPage(1);
            } else {
              this.activeTab = 'all-proposals';
              this.proposalsTableRef.getPage(1);
              this.draftsTableRef.getPage(1);
            }

            Swal.fire(i18n.deleted, selected.length == 1 ? i18n.proposal.proposal_deleted : i18n.proposal.proposals_deleted, 'success');

          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }
  }

  markAsSent(selected: Array<string>) {
    if (selected.length) {
      this.loaderService.startLoading();

      this.proposalService.action({ 'do': PROPOSAL_ACTIONS.MARK_AS_SENT, 'ids': selected }).subscribe(data => {
        Swal.fire('', i18n.proposal.marked_as_sent, 'success');
        this.proposalsTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  markAsApproved(selected: Array<string>) {
    if (selected.length) {
      this.loaderService.startLoading();

      this.proposalService.action({ 'do': PROPOSAL_ACTIONS.MARK_AS_APPROVED, 'ids': selected }).subscribe(data => {
        Swal.fire('', i18n.proposal.marked_as_approved, 'success');
        this.proposalsTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  markAsRejected(selected: Array<string>) {
    if (selected.length) {
      this.loaderService.startLoading();

      this.proposalService.action({ 'do': PROPOSAL_ACTIONS.MARK_AS_REJECTED, 'ids': selected }).subscribe(data => {
        Swal.fire('', i18n.proposal.marked_as_rejected, 'success');
        this.proposalsTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  markAsViewed(selected: Array<string>) {
    if (selected.length) {
      this.loaderService.startLoading();

      this.proposalService.action({ 'do': PROPOSAL_ACTIONS.MARK_AS_VIEWED, 'ids': selected }).subscribe(data => {
        Swal.fire('', i18n.proposal.marked_as_viewed, 'success');
        this.proposalsTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  convertToInvoice(selected: Array<string>) {
    if (selected.length) {
      this.loaderService.startLoading();

      this.proposalService.action({ 'do': PROPOSAL_ACTIONS.CONVERT_TO_INVOICE, 'ids': selected }).subscribe(data => {
        Swal.fire('', i18n.proposal.converted_to_invoice, 'success');
        this.proposalsTableRef.getPage(1);
        this.draftsTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

}
